export const getPortCodesForSegments = (segments) => {
  const stopCodes = segments.map(s => s.Details.DepStation);
  stopCodes.push(segments[segments.length - 1].Details.ArrStation)
  return stopCodes;
}